import { render } from "./ViewServiceTerms.vue?vue&type=template&id=173e56a4&scoped=true"
import script from "./ViewServiceTerms.vue?vue&type=script&lang=js"
export * from "./ViewServiceTerms.vue?vue&type=script&lang=js"

import "./ViewServiceTerms.vue?vue&type=style&index=0&id=173e56a4&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173e56a4"]])

export default __exports__